/**
 * @generated SignedSource<<279e0d1bfe7ed34098933e9a8f80133d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisableDocusignInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DisableDocusignMutation$variables = {
  input: DisableDocusignInput;
};
export type DisableDocusignMutation$data = {
  readonly disableDocusign: {
    readonly company: {
      readonly id: string;
      readonly docusignEnabled: boolean | null;
    } | null;
  } | null;
};
export type DisableDocusignMutation = {
  variables: DisableDocusignMutation$variables;
  response: DisableDocusignMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DisableDocusignPayload",
    "kind": "LinkedField",
    "name": "disableDocusign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "docusignEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisableDocusignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisableDocusignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "25b69adf5a03e18ef54bc0bc09076932",
    "id": null,
    "metadata": {},
    "name": "DisableDocusignMutation",
    "operationKind": "mutation",
    "text": "mutation DisableDocusignMutation(\n  $input: DisableDocusignInput!\n) {\n  disableDocusign(input: $input) {\n    company {\n      id\n      docusignEnabled\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44f78a06942da8ae5865c091a3482f11";

export default node;
